import theme from "../../style/theme";
import styled from "styled-components";

interface RoundedTextBadgeProps {
    text: string;
    backgroundColor?: string;
    textColor?: string;
    clientName: string;
}

function stringToHexColor(input: string): string {
    // 1. 문자열 해싱
    let hash = 0;
    for (let i = 0; i < input.length; i++) {
        hash = input.charCodeAt(i) + ((hash << 5) - hash);
    }

    // 2. 해시를 Hex 코드로 변환
    let color = "#";
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xFF;
        color += ('00' + value.toString(16)).slice(-2);
    }

    return color;
}

function getContrastYIQ(hexColor: string): string {
    hexColor = hexColor.replace("#", "");
    const r = parseInt(hexColor.substr(0, 2), 16);
    const g = parseInt(hexColor.substr(2, 2), 16);
    const b = parseInt(hexColor.substr(4, 2), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? theme.palette.primitives.gray900 : theme.palette.primitives.white;
}

const RoundedTextBadge: React.FC<RoundedTextBadgeProps> = (
    {
        text,
        backgroundColor,
        textColor,
        clientName,
    }
) => {
    return (
        <TextBadgeContainer backgroundColor={stringToHexColor(clientName)}>
            <Text textColor={getContrastYIQ(clientName)}>{text}</Text>
        </TextBadgeContainer>
    );
};

const TextBadgeContainer = styled.div<{ backgroundColor: string }>`
  background-color: ${({backgroundColor}) => backgroundColor};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 4px;
`;

const Text = styled.span<{ textColor: string }>`
  font-weight: 500;
  //line-height: 14px;
  font-size: 11px;
  color: ${({textColor}) => textColor};
`;

RoundedTextBadge.defaultProps = {
    backgroundColor: `${theme.palette.primitives.red400}`,
    textColor: `${theme.palette.primitives.gray50}`,
};

export default RoundedTextBadge;
